import type { ReactElement } from 'react';

import { OpeningForm } from '../../../components/forms/openingForm';
import { ContentContainer } from '../../../components/layout/contentContainer';
import { HeaderContainer } from '../../../components/layout/headerContainer';
import { OfflineChatHeader } from '../../../components/offlineChat/offlineChatHeader';

const OfflineChat = (): ReactElement => (
	<>
		<HeaderContainer>
			<OfflineChatHeader />
		</HeaderContainer>
		<ContentContainer>
			<OpeningForm />
		</ContentContainer>
	</>
);

export { OfflineChat };
